import Taskpane from './Taskpane';

export default Taskpane;
